import { render, staticRenderFns } from "./adminstor.vue?vue&type=template&id=abfbb9fe&scoped=true&"
import script from "./adminstor.vue?vue&type=script&lang=js&"
export * from "./adminstor.vue?vue&type=script&lang=js&"
import style0 from "./adminstor.vue?vue&type=style&index=0&id=abfbb9fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfbb9fe",
  null
  
)

export default component.exports